import React from 'react';
import { getEnvironment, isProduction } from '../config/environment';

/**
 * Environment Badge Component
 * Shows current environment in non-production environments
 * Helps prevent accidentally working in the wrong environment
 */
// Public, client-facing surfaces. Even if REACT_APP_ENV is missing/misconfigured
// (which is exactly what put a blue "DEV" pill on the live lead-capture form),
// a prospect must never see an internal environment badge.
const PUBLIC_PATH_PREFIXES = [
  '/embed/', '/live/', '/live-experience', '/card', '/check-availability',
  '/client-view/', '/songs/', '/feedback/', '/brief/', '/payment-success',
  '/terms', '/privacy',
];
const EnvironmentBadge = () => {
  // Don't show anything in production
  if (isProduction()) {
    return null;
  }
  // Never render on a public/embedded surface, regardless of environment.
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  if (PUBLIC_PATH_PREFIXES.some((p) => path === p || path.startsWith(p))) {
    return null;
  }

  const env = getEnvironment();
  
  const badgeStyles = {
    development: {
      bg: 'bg-blue-500',
      text: 'DEV',
      description: 'Development Environment'
    },
    staging: {
      bg: 'bg-amber-500', 
      text: 'STAGING',
      description: 'Staging Environment - Test changes here'
    }
  };

  const style = badgeStyles[env] || badgeStyles.development;

  return (
    <div 
      className={`fixed bottom-4 left-4 z-[9999] ${style.bg} text-white px-3 py-1.5 rounded-full text-xs font-bold shadow-lg flex items-center gap-2 cursor-help`}
      title={style.description}
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
      </span>
      {style.text}
    </div>
  );
};

export default EnvironmentBadge;
